import { WebchatConfiguration, WebchatConfigurationKeys } from './types';

const config: WebchatConfiguration = {
  [WebchatConfigurationKeys.APP_INSIGHTS_CONNECTION_STRING]:
    'InstrumentationKey=c7dc1019-955b-4e1c-898f-91a4a910b625;IngestionEndpoint=https://northeurope-0.in.applicationinsights.azure.com/',
  [WebchatConfigurationKeys.GOOGLE_TAG_MANAGER_KEY]: 'GTM-T366PF4',
};

export default config;
